import './megamenu.js'
import './tabs.js'
import './products.js'
import './dropdown.js'
import './vinnyselect.js'
import './product-mapping.js'
import './product-standard.js'
import './integer.js'
import './faqs.js'
import './header-rating.js'
import './modals.js'
import './components/vinnybox-v2.js';
import './components/jquery.mmenu.all.min.js';
import {disableAccessibility} from "./splide-disable-accessibility";
import Splide from '@splidejs/splide';
import imagesLoaded from 'imagesloaded';

$(function(){

    // CYCLE DELAY TIME
    $.fn.cycleDelay = function(delayTime, delayStart) {
        let delay = 0,
            element = this;

        if (delayStart !== undefined )
        {
            delay = delayStart;
        }

        if (delayTime === undefined){
            element.each(function() {
                $(this).css({
                    'transition-delay': '0.8s, 0s'
                });
            });
        } else {
            element.each(function(){
                $(this).css({
                    'transition-delay' : delay+'s, '+ delay +'s'
                });

                delay = delay + delayTime;
            })
        }
    };

    // MMENU
    let mobileMenu = $('.mobile-menu');

    mobileMenu.find('.has-sub').removeAttr('aria-haspopup').removeAttr('aria-expanded');

    mobileMenu.mmenu({
        offCanvas: {
            zposition: 'rear',
            position: 'left'
        },
        screenReader: {
            aria: true,
            text: true
        },
        keyboardNavigation: true,
    }, {
        classNames: {
            fixedElements: {
                fixed: 'fix'
            }
        }
    });

    let api = mobileMenu.data('mmenu'),
        mobileOpen = $('.mobile-open');

    mobileOpen.on('click keydown', function (e) {
        if (e.type === 'click' || e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            if ($('html').hasClass('mm-opened')) {
                mobileOpen.attr('aria-expanded', 'false').attr('aria-label', 'Open mobile menu');
                api.close()

                mobileOpen.focus();
            } else {
                mobileOpen.attr('aria-expanded', 'true').attr('aria-label', 'Close mobile menu');
                api.open()

                mobileMenu.find('.mm-current [href]').first().focus();
            }
        }

        // if shift tab
        if (e.shiftKey && e.keyCode === 9) {
            e.preventDefault();
            mobileMenu.find('.mm-current [href]').last().focus();
        }

        // if tab
        if (!e.shiftKey && e.keyCode === 9) {
            e.preventDefault();
            mobileMenu.find('.mm-current [href]').first().focus();
        }
    });

    mobileMenu.on('keydown', function(e){
        if (e.keyCode === 27) {
            api.close();
        }
    });

    mobileMenu.find('.mm-next > .mm-sronly').each(function(){
        let thisSr = $(this);

        if (thisSr.text() === 'Open submenu') {
            thisSr.text('Open ' + thisSr.parent().prev().text() + ' submenu');
        }
    });

    $('.mm-tabend').on('focus', function(e){
        e.preventDefault();
        mobileOpen.focus();
    })

    $('.mm-tabstart').on('focus', function(e){
        e.preventDefault();
        mobileOpen.focus();
    })

    // SLIDER
    let slider = $('#slider');

    if (slider.length) {
        let slideBgs = new Splide('.slide-bgs', {
            type: 'fade',
            speed: 2000,
            arrows: false,
            dots: false,
            rewind: true,
            pagination: false,
        });

        let slideContents = new Splide('.slide-contents', {
            type: 'fade',
            speed: 2000,
            arrows: false,
            rewind: true,
            autoplay: true,
            interval: 5000,
        });

        slideContents.sync(slideBgs);

        slideContents.on('ready', function () {
            let root = $(slideContents.root),
                active = root.find('.splide__slide.is-active');

            active.find('.slide-inner > .slide-title > span, .slide-inner > *:not(.slide-title)').cycleDelay(0.2, 0.2);
            active.addClass('slide-anim');
            slider.addClass('anim');

            if (active.hasClass('slide-white')) {
                root.addClass('slide-white');
            } else {
                root.removeClass('slide-white');
            }
        });

        slideContents.on('move', function (newIndex, previousIndex, destIndex) {
            let root = $(slideContents.root);

            root.find('.slide-anim').removeClass('slide-anim').find('.slide-inner > .slide-title > span, .slide-inner > *:not(.slide-title)').cycleDelay()

            let next = root.find('.splide__slide').eq(destIndex);

            setTimeout(function () {
                next.find('.slide-inner > .slide-title > span, .slide-inner > *:not(.slide-title)').cycleDelay(0.2);
                next.addClass('slide-anim');
            }, 400);

        });

        slideBgs.mount({disableAccessibility});
        slideContents.mount();
    }

    // LINK SLIDES
    let linkSlides = $('.link-slides');

    if (linkSlides.length) {
        let linkSlider = new Splide('.link-slides', {
            type: 'slide',
            speed: 400,
            perPage: 3,
            perMove: 1,
            gap: '30px',
            arrows: false,
            pagination: false,
            breakpoints: {
                1400: {
                    gap: '20px',
                },
                1050: {
                    gap: '16px',
                },
                900: {
                    perPage: 2,
                },
                750: {
                    gap: '8px',
                },
                550: {
                    perPage: 1,
                },
            }
        });

        linkSlider.mount();

        $('.link-slide-nav-btn').on('click', function(){
            if ($(this).hasClass('link-slide-nav-prev')) {
                linkSlider.go('<');
            } else {
                linkSlider.go('>');
            }
        })
    }

    // CTA SLIDER
    let ctaSlider = $('#cta-slider');

    if (ctaSlider.length) {
        let ctaBgs = new Splide('.cta-slide-bgs', {
            type: 'fade',
            speed: 2000,
            arrows: false,
            dots: false,
            rewind: true,
            pagination: false,
        });

        let ctaContents = new Splide('.cta-slide-contents', {
            type: 'fade',
            speed: 2000,
            arrows: false,
            rewind: true,
            autoplay: true,
            interval: 5000,
        });

        ctaContents.sync(ctaBgs);

        ctaContents.on('ready', function () {
            let root = $(ctaContents.root),
                active = root.find('.splide__slide.is-active');

            active.find('.cta-slide-inner > *').cycleDelay(0.2, 0.2);
            active.addClass('slide-anim');
        });

        ctaContents.on('move', function (newIndex, previousIndex, destIndex) {
            let root = $(ctaContents.root);

            root.find('.slide-anim').removeClass('slide-anim').find('.cta-slide-inner > *').cycleDelay()

            let next = root.find('.splide__slide').eq(destIndex);

            setTimeout(function () {
                next.find('.cta-slide-inner > *').cycleDelay(0.2);
                next.addClass('slide-anim');
            }, 400);

        });

        ctaBgs.mount({disableAccessibility});
        ctaContents.mount();
    }

    // REVIEWS SLIDER
    let reviewsSlides = $('.reviews-slides');

    if (reviewsSlides.length) {
        let reviewsSlider = new Splide('.reviews-slides', {
            type: 'slide',
            speed: 400,
            perPage: 3,
            perMove: 1,
            gap: '30px',
            arrows: false,
            pagination: false,
            breakpoints: {
                1400: {
                    gap: '20px',
                    perPage: 2,
                },
                1050: {
                    gap: '16px',
                    perPage: 1,
                },
                750: {
                    gap: '8px',
                },
            }
        });

        reviewsSlider.mount();

        $('.reviews-slide-nav-btn').on('click', function(){
            if ($(this).hasClass('reviews-slide-nav-prev')) {
                reviewsSlider.go('<');
            } else {
                reviewsSlider.go('>');
            }
        })
    }

    // REVIEWS SLIDER
    let postsSlides = $('.posts-slides');

    if (postsSlides.length) {
        let postsSlider = new Splide('.posts-slides', {
            type: 'slide',
            speed: 400,
            perPage: 3,
            perMove: 1,
            gap: '30px',
            arrows: false,
            pagination: false,
            breakpoints: {
                1400: {
                    gap: '20px',
                },
                1200: {
                    perPage: 2,
                },
                1050: {
                    gap: '16px',
                },
                750: {
                    perPage: 1,
                    gap: '8px',
                },
            }
        });

        postsSlider.mount();

        $('.posts-slides-nav-btn').on('click', function(){
            if ($(this).hasClass('posts-slides-nav-prev')) {
                postsSlider.go('<');
            } else {
                postsSlider.go('>');
            }
        })
    }

    // BANNER
    let banner = $('#banner');

    if (banner.length > 0) {
        imagesLoaded(banner, function(){
            banner.find('.banner-content > *').cycleDelay(0.12, 0.32);
            banner.addClass('anim');
        });
    }

    // PRODUCT GALLERY
    let galleryMain = $('.product-images');

    if (galleryMain.length) {
        let productImages = new Splide('.product-images', {
            type: 'fade',
            arrows: false,
            speed: 600,
            pagination: false,
            drag: false,
        });

        if ($('.product-thumbs').length) {
            let productThumbs = new Splide('.product-thumbs', {
                type: 'slide',
                perPage: 2,
                perMove: 1,
                arrows: false,
                speed: 400,
                gap: '30px',
                pagination: false,
                breakpoints: {
                    1400: {
                        gap: '20px',
                    },
                    1050: {
                        gap: '16px',
                    },
                    750: {
                        gap: '8px',
                    },
                }
            });

            productThumbs.on('click', function (slide) {
                productImages.go(slide.index);
            });

            $('.product-thumb-nav-btn').on('click', function(){
                if ($(this).hasClass('product-thumb-nav-next')) {
                    productThumbs.go('+1');
                } else {
                    productThumbs.go('-1');
                }
            })

            productThumbs.mount();
        }

        productImages.mount();
    }

    // VINNYSELECT
    $('select').vinnyselect();

    // VINNYBOX
    $('.vinnybox').vinnybox({
        className: '.vinnybox',
        autoplay: false,
        vinnyboxBackground: 'rgba(0,0,0,0.8)'
    });

    // HEADSPACE
    let headSpace = $('.head-space'),
        headerTop = $('.header-top'),
        headerTopContainer = $('.header-top-container'),
        headerFixedElements = $('.header-fixed-elements'),
        header = $('#header'),
        navTopRight = $('.nav-top-right'),
        headerMainInfo = $('.header-main-info-inner'),
        headerRating = $('.header-rating');

    function updateHeadSpace() {
        headSpace.height(Math.floor(headerTop.outerHeight() + headerFixedElements[0].scrollHeight));
    }

    updateHeadSpace();
    $(window).on('resize', updateHeadSpace);

    // HEADER SEARCH
    let searchFormInputTrigger = $('.search-form-input-trigger'),
        searchForminput = $('#searchInput');

    searchFormInputTrigger.on('click', function(e){
        if (window.innerWidth <= 1200) {
            e.preventDefault();
            openSearch();
        }
    })

    $('.search-form-close').on('click', closeSearch);

    $('body').on('click', function(e){
        if (!$(e.target).closest('#header').length) {
            closeSearch();
        }
    });

    function openSearch() {
        header.addClass('search-open');
        searchForminput.focus();
    }

    function closeSearch() {
        $('#searchContainer').removeClass('open');
        header.removeClass('search-open');
    }

    // SHARING
    $('.product-sharing-btn').on('click', function(){
         $('.product-sharing-popup').slideDown(200);
    });

    $('[href]').on('click keydown', function(e){
        let href = $(this).attr('href');

        if (href[0] == '#' && !$(this).hasClass('mm-fullsubopen')) {
            e.preventDefault();
            scrollToId(href);
        }
    });

    // INIT SCROLL
    let initScroll = $('#init-scroll');

    if (initScroll.length > 0) {
        setTimeout(function(){
            scrollToId('#init-scroll', 75)
        }, 500)
    }

    // THROTTLE 1
    let ticking = false;

    function checkHeader() {
        if (window.scrollY > headerTop.outerHeight()) {
            fixHeader();
        } else {
            unfixHeader();
        }
    }

    $(window).on('resize', function(){
        if (window.innerWidth <= 1200) {
            if (headerTopContainer.find('.nav-top-right').length === 0) {
                headerTopContainer.append(navTopRight);
            }
        } else {
            checkHeader();
        }
    });

    function fixHeader() {
        if (header.hasClass('fixed')) {
            return;
        }

        if (window.innerWidth > 1200) {
            headerRating.addClass('hide')

            navTopRight.stop().fadeOut(200, function(){
                headerMainInfo.append(navTopRight);
                navTopRight.fadeIn(200);
            })
        }

        header.addClass('fixed');
    }

    function unfixHeader() {
        if (!header.hasClass('fixed')) {
            return;
        }

        if (window.innerWidth > 1200) {
            navTopRight.stop().fadeOut(200, function () {
                headerTopContainer.append(navTopRight);
                navTopRight.fadeIn(200);
                headerRating.removeClass('hide')
            })
        }

        header.removeClass('fixed');
    }

    function update() {
        checkHeader ();

        ticking = false;
    }

    update();
    document.addEventListener("scroll", function() {
        if (!ticking) {
            ticking = requestAnimationFrame(update);
        }
    }, {passive: true});
})

// HEADER OFFSET
function headerOffset() {
    if (window.innerWidth > 1200) {
        return 96;
    } else if (window.innerWidth > 750) {
        return 93;
    }

    return 72;
}

// SCROLL TO ID
export function scrollToId(id, offset) {
    let scrollObject;

    if (typeof id === 'object') {
        scrollObject = id;
    } else {
        if (id[0] !== '#') {
            id = '#' + id;
        }

        scrollObject = $(id);
    }

    if (!offset) {
        offset = 0;
    }

    $('html').stop().animate({
        scrollTop: scrollObject.offset().top - headerOffset() - offset
    }, 600);
}

// HTML NO SCROLL
let html = $('html'),
    body = $('body'),
    offsetTop;

export function stopScroll() {
    offsetTop = window.scrollY;
    html.addClass('stopping-scroll');
    body.css('top', '-' + offsetTop + 'px');
    html.addClass('no-scroll');
}

export function startScroll() {
    body.css('top', '');
    html.removeClass('no-scroll stopping-scroll');
    html.scrollTop(offsetTop);
}